import { normalizeExportAnnotations, normalizeWerkplan } from "./werkplanDefaults";

export {
  DEFAULT_EXPORT_ANNOTATIONS,
  DEFAULT_WERKPLAN,
  normalizeExportAnnotations,
  normalizeWerkplan,
} from "./werkplanDefaults";

export function buildExportDraft(werkplan, annotations, rows, layout) {
  const normalizedWerkplan = normalizeWerkplan(werkplan);
  const normalizedAnnotations = normalizeExportAnnotations(annotations);

  return {
    ...normalizedWerkplan,
    sheetStrategies: (layout?.sheets || []).reduce((result, sheet) => {
      result[sheet.index] = normalizedAnnotations.sheetStrategies[sheet.index] || "inherit";
      return result;
    }, {}),
    sheetNotes: (layout?.sheets || []).reduce((result, sheet) => {
      result[sheet.index] = normalizedAnnotations.sheetNotes[sheet.index] || "";
      return result;
    }, {}),
    rowOverrides: rows.reduce((result, row) => {
      const saved = normalizedAnnotations.rowOverrides[row.id];
      result[row.id] = {
        orderLength: saved?.orderLength,
        orderWidth: saved?.orderWidth,
        instruction: saved?.instruction ?? "",
        instructionEdited: saved?.instructionEdited ?? false,
        orderSizeEdited: saved?.orderSizeEdited ?? false,
      };
      return result;
    }, {}),
  };
}
